import CSSModules from 'react-css-modules';
import React from 'react';
import { ShareActionOptions } from 'src/redux/modules/page';
import { buildUrl } from 'src/helpers/url';
import { generateHash } from '../../helpers/hashId';
import { openCenteredPopup } from 'src/helpers/window';
import styles from './LinkedInShareButton.scss';
import { useTrackEvent } from '@optimizely/react-sdk';

export interface Props {
  shareOnLinkedIn: (options: ShareActionOptions) => void;
  socialShareUrl: string;
  isActive: boolean;
  pageSection: string;
  ownerName: string;
  buttonText?: string;
}

const LinkedInShareButton: React.StatelessComponent<Props> = ({
  pageSection,
  shareOnLinkedIn,
  socialShareUrl,
  isActive,
  buttonText,
}) => {
  const [track] = useTrackEvent();

  const handleLinkedInShare = () => {
    track('shareSocialButtonClick');
    const shareHash = generateHash();

    shareOnLinkedIn({
      shareHash,
      location: pageSection,
    });

    const pageUrl = buildUrl(socialShareUrl, {
      utm_term: shareHash,
    });

    if (__CLIENT__) {
      openCenteredPopup(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          pageUrl
        )}`,
        1000,
        760
      );
    }
  };

  return (
    <div styleName="share-button-container">
      <button
        type="button"
        disabled={!isActive}
        className={styles.linkedin}
        onClick={handleLinkedInShare}
      >
        {buttonText || 'LinkedIn'}
      </button>
    </div>
  );
};

export default CSSModules(LinkedInShareButton, styles);
